import { getOneTimeRecurringDescription } from './forms/utils/posTaskSchedule'
import { STATUS_DIC, TASK_TYPE_DIC } from './constants/constants'
import { TASK_QUALIFIER_FIELDS } from './forms/components/TaskAttributeHelper'
import { capitalizeFirstLetterFrom } from '../helpers/utils'

export const getQualifiers = (qualifiers) => {
  if (!qualifiers || qualifiers.length === 0) return ''
  return `${qualifiers.join(', ')} `
}

export const getClientOrAttribute = (model) =>
  [
    getQualifiers(model.client_names),
    ...TASK_QUALIFIER_FIELDS.filter(({ key }) => model[key]?.length > 0).map(
      ({ key, label }) => `${label} - ${getQualifiers(model[key])}`
    )
  ]
    .filter(Boolean)
    .join('')

export const getFormattedDateOnly = (date) => {
  if (!date) return 'Sin fecha'
  return new Date(date).toLocaleDateString(undefined, { timeZone: 'utc' })
}

export const checkValue = (value) =>
  value === null || value === undefined || value === '' ? '-' : value

export const getRecurrenceText = (model) => {
  if (model.completion_mode === 'once' || model.recurrence_type === 'once') return 'Una sola vez'
  if (model.completion_mode === 'once_per_period' || model.recurrence_type === 'once_per_period') {
    return capitalizeFirstLetterFrom(getOneTimeRecurringDescription(model.recurrence_interval))
  }
  if (model.recurrence_description) {
    return capitalizeFirstLetterFrom(model.recurrence_description)
  }
  return '-'
}

export const getStatusLabel = (status) => STATUS_DIC[status] || status || '-'

export const getTaskTypeLabel = (taskType) => TASK_TYPE_DIC[taskType] || taskType || '-'
